var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilteriIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1144 11.9992V17.2493C10.0928 17.4781 10.1575 17.6601 10.3069 17.797C10.458 17.9323 10.624 18 10.8066 18C10.9892 18 11.1552 17.9372 11.3062 17.8131L12.6591 16.4696C12.83 16.3037 12.9064 16.1152 12.8848 15.9074V12.0008L16.8454 7.09384C16.9749 6.94724 17.023 6.78131 16.9898 6.59444C16.9566 6.40757 16.872 6.26097 16.7325 6.15626C16.5931 6.05155 16.4487 6 16.2976 6H6.70156C6.5505 6 6.40609 6.05155 6.26665 6.15626C6.12722 6.26097 6.0409 6.40435 6.00936 6.59283C5.97782 6.78131 6.02596 6.94724 6.15378 7.09223L10.1144 11.9992Z",
    fill: "#444F59",
    fillOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilteriIcon);
export default __webpack_public_path__ + "static/media/filteriIcon.d18ea7cb847d9a116a9bfe5b568a8d74.svg";
export { ForwardRef as ReactComponent };